import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export const TomosSection = memo(function TomosSection() {
  const tomos = [{
    icon: '💀',
    title: 'Tomo 1 — El Despertar',
    subtitle: 'El diagnóstico que nadie quiere hacer pero que lo cambia todo.',
    desc: 'Calculás en dinero real cuánto te costó la distracción este año. Inventariás los proyectos que mataste sin darte cuenta. Medís tu nivel de saturación dopamínica y ejecutás tu primer reset de emergencia en las próximas 24 horas.',
    value: '$8.900'
  }, {
    icon: '🧬',
    title: 'Tomo 2 — Bio-Hack Dopamínico',
    subtitle: 'La reprogramación biológica que el algoritmo no quiere que tengas.',
    desc: 'Entendés los 4 químicos que determinan tu rendimiento mental y por qué están comprometidos. Ejecutás el Ayuno Dopamínico de 24 horas que resetea tus receptores e instalás el Protocolo de Encendido de 90 minutos.',
    value: '$8.900'
  }, {
    icon: '🏗️',
    title: 'Tomo 3 — Ingeniería de Entorno',
    subtitle: 'Diseñá el campo de batalla para que el enfoque sea inevitable.',
    desc: 'Rediseñás tu espacio físico y digital para que el foco sea el camino de menor resistencia. Configurás el celular en Modo Guerra, identificás a los saboteadores de tu entorno y reprogramás los patrones de pensamiento que frenan tu ejecución.',
    value: '$8.900'
  }, {
    icon: '⏰',
    title: 'Tomo 4 — El Sistema de los 3 Bloques',
    subtitle: 'Acá empieza la ejecución. Acá empieza el avance real.',
    desc: 'Diseñás tu Bloque de Creación y lo blindás contra interrupciones. Contenés la comunicación en ventanas definidas. Usás la recuperación como combustible y construís tu Día Perfecto personalizado según tu cronotipo.',
    value: '$8.900'
  }, {
    icon: '🚨',
    title: 'Tomo 5 — El Antídoto S.O.S.',
    subtitle: 'El arsenal para cuando tu cerebro dice "ahora no".',
    desc: 'Tenés 10 intervenciones técnicas para el momento exacto del bloqueo. Diagnosticás tu estado de resistencia en 30 segundos. Instalás el Sistema de Micro-Victorias que genera dopamina de logro sostenida cada día.',
    value: '$8.900'
  }, {
    icon: '🏆',
    title: 'Tomo 6 — Nueva Identidad Ejecutora',
    subtitle: 'El que instala esto deja de intentar y empieza a terminar.',
    desc: 'Hacés la autopsia de tu identidad vieja y construís las 5 características de la Identidad Ejecutora. Blindás el sistema contra las amenazas que inevitablemente aparecen y escribís tu Manifiesto del Nuevo Vos.',
    value: '$8.900'
  }];
  return <section className="py-16 bg-gray-50 text-gray-900 overflow-hidden border-t border-gray-200" data-id="element-168">
      <div className="max-w-5xl mx-auto px-4" data-id="element-169">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-170">
          <h2 className="text-[26px] md:text-4xl font-black text-gray-900 mb-4 leading-tight" data-id="element-171">
            6 Tomos que te llevan de coma digital{' '}
            <span className="text-yellow-500" data-id="element-172">
              a ejecutar sin excusas.
            </span>
          </h2>
          <p className="text-gray-500 text-[13px] md:hidden" data-id="element-173">
            Deslizá para ver todos los tomos 👈
          </p>
        </div>
      </div>

      {/* Carrusel */}
      <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory px-4 pb-4 scrollbar-hide md:max-w-5xl md:mx-auto md:flex-wrap md:justify-center md:overflow-visible" data-id="element-174">
        {tomos.map((tomo, i) => <div key={i} className="min-w-[280px] max-w-[300px] md:min-w-0 md:w-[calc(33.333%-1rem)] snap-start bg-white rounded-2xl border border-gray-200 p-5 flex flex-col gap-3 shadow-sm hover:shadow-md transition-shadow" data-id="element-175">
            <div className="text-3xl" data-id="element-176">{tomo.icon}</div>
            <h3 className="text-lg font-bold text-gray-900 leading-snug" data-id="element-177">
              {tomo.title}
            </h3>
            <p className="text-sm font-semibold text-yellow-500" data-id="element-178">
              {tomo.subtitle}
            </p>
            <p className="text-sm text-gray-600 leading-relaxed flex-1" data-id="element-179">
              {tomo.desc}
            </p>
            <p className="text-xs text-gray-400 mt-auto" data-id="element-180">
              Valor individual:{' '}
              <span className="line-through" data-id="element-181">{tomo.value}</span>
            </p>
          </div>)}
      </div>

      {/* CTA */}
      <div className="max-w-5xl mx-auto px-4 mt-10 text-center" data-id="element-182">
        <CTAButton href="#compra" text="🧠 QUIERO DOMINAR MI MENTE" subtext="🔒 Pago seguro · Acceso inmediato · Garantía 30 días" data-id="element-183" />
      </div>
    </section>;
});